import { isNotebookViewPath } from './pathnameHelpers';

export default function isNotebookViewUrl(): boolean {
  return isNotebookViewPath(window.location.pathname);
}
